import { PackageBuilderModel } from './package-builder.model';

export class StaggeredPackageBuilderModel {
  front: PackageBuilderModel;
  rear: PackageBuilderModel;

  constructor() {
    this.front = new PackageBuilderModel();
    this.rear = new PackageBuilderModel();
  }
}
